import { render, staticRenderFns } from "./DesktopNavigation.vue?vue&type=template&id=005bbe5d"
import script from "./DesktopNavigation.vue?vue&type=script&lang=ts"
export * from "./DesktopNavigation.vue?vue&type=script&lang=ts"
import style0 from "./DesktopNavigation.vue?vue&type=style&index=0&id=005bbe5d&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports